import moment from 'moment';

/**
 * 设置 x_pss_id
 * @param {string} id
 */
export const setPssId = (id, verification = false) => {
  if (id) {
    const userAgent = window.navigator.userAgent.toLowerCase();

    if (md.global.Config.IsLocal && md.global.Config.SessionCookieExpireMinutes) {
      const expireDate = moment()
        .add(md.global.Config.SessionCookieExpireMinutes, 'm')
        .toDate();
      window.setCookie('x_pss_id', id, expireDate);
    } else if (
      verification ||
      userAgent.includes('dingtalk') ||
      userAgent.includes('miniprogram') ||
      location.href.indexOf('localhost') > -1
    ) {
      window.setCookie('x_pss_id', id);
    }

    if (window.top !== window.self || md.global.Config.HttpOnly) {
      safeLocalStorageSetItem('x_pss_id', id);
    }
  }
};

/**
 * 获取 x_pss_id
 * @returns {string} x_pss_id
 */
export const getPssId = () => {
  const storagePssId = window.localStorage.getItem('x_pss_id');
  const cookiePssId = window.getCookie('x_pss_id');

  return cookiePssId || storagePssId;
};

/**
 * 删除 x_pss_id
 */
export const removePssId = () => {
  window.delCookie('x_pss_id');
  window.localStorage.removeItem('x_pss_id');
};
